import { render, staticRenderFns } from "./lyhHeader.vue?vue&type=template&id=44ff3fe2&scoped=true"
import script from "./lyhHeader.vue?vue&type=script&lang=js"
export * from "./lyhHeader.vue?vue&type=script&lang=js"
import style0 from "./lyhHeader.vue?vue&type=style&index=0&id=44ff3fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff3fe2",
  null
  
)

export default component.exports